import React, { useState, useEffect } from 'react';
import CardContainer from '../../../components/card/card-container.jsx';
import Api from '../../../api/global.service';
import env from '../../../environment.js';
import { subscribe, unsubscribe } from '../../../components/events';
import './entregas-x-productor.css';
import ExampleCustomInput from '../../../components/modal/input.jsx';
import DatePicker from 'react-datepicker';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import formatMoneyNumber, { formatNumber } from '../../../utils/formatNumber.js';
import unidadAcopioConvertible from '../../../utils/unidadAcopioConvertible.js';
import { es } from 'date-fns/locale';
import { useCoopConfig,precioPorKgPrecargado, precioPorKgPorProductor } from '../../../components/content/coop-config.jsx';
import EntregasXProductorInfoXKilos from './entregas-x-productor-info-acopio-x-kilos.js';
import FormInputMaterialTest from '../../../nuup/componentes/Forms/FormInputMaterialTest.jsx';
import EntregasXProductorFirmaXKilos from './entregas-x-productor-firma-pago-pendiente-x-kilos.js';
import { patternNumero2Decimales, patternNumero3Decimales, patternNumero4Decimales } from '../../../utils/redexPatterns.js';

var curr = new Date();

const EntregasXProductorPagoPendienteXKilos = () => {
  const coopConfig = useCoopConfig();
  const { id_ciclo, id_cuenta, uuid_cuenta } = useParams();
  const [dataForm, setDataForm] = useState({});
  const [showForm, setShowForm] = useState(true);
  const [showFirma, setShowFirma] = useState(false);
  const [metodosPago, setMetodosPago] = useState([]);
  const [entregas, setEntregas] = useState();
  const [cuenta, setCuenta] = useState();
  const [unit, setUnit] = useState('kg');
  const [pendientePagoCredito, setPendientePagoCredito] = useState(0);

  useEffect(() => {
    if (coopConfig.hasAcopioUnitsExtra()) {
      setUnit(coopConfig.acopioUnitsExtra()?.abreviacion);
    } else {
      setUnit(coopConfig.acopioUnits()?.abreviacion);
    }
  }, [coopConfig.config]);

  useEffect(() => {
    getMetodosPago();
    consultaPreciosPrecargados();
  }, []);

  useEffect(() => {
    subscribe('Entrega::onReturn', e => handleReturn(e));
    subscribe('Entrega::Entregas', e => handleEntregas(e));
    subscribe('Entrega::Cuenta', e => handleCuenta(e));
    subscribe('Entrega::Creditos', e => handleCreditos(e));
    return () => {
      unsubscribe('Entrega::onReturn');
      unsubscribe('Entrega::Entregas');
      unsubscribe('Entrega::Creditos');
    };
  }, []);

  const handleCuenta = event => {
    setCuenta(event.detail);
  };

  const handleEntregas = event => {
    setEntregas(event.detail);
  };

  const handleCreditos = event => {
    setValue('creditos', event.detail.raw);
    setPendientePagoCredito(event.detail.total_saldo);
  };

  const handleReturn = () => {
    setShowForm(true);
    setShowFirma(false);
  };

  const [formData] = useState({
    id_ciclo: localStorage.getItem(`${env.appName}-ciclo_id`),
    fecha_ejecucion: curr,
    id_metodo_pago: '',
    precio_x_kg: 0,
    kgs_a_pagar: 0,
    monto_descontar: 0,
  });

  const schema = yup.object().shape({
    id_cuenta: yup.number().min(1),
    fecha_ejecucion: yup
      .date()
      .nullable()
      .transform((curr, orig) => (orig === '' ? null : curr))
      .required('Información obligatoria'),
    id_metodo_pago: yup.mixed().test({
      message: 'Información obligatoria',
      test: val => val.value > 0,
    }),
    precio_x_kg: yup
      .number()
      .typeError('Debe ser un número')
      .min(0.001, 'El precio debe ser mayor a 0')
      .test('is-decimal', 'Solo se permiten tres decimales', value => {
        if (value === null || value === undefined) return true;
        return patternNumero3Decimales.test(value);
      })
      .required('Información obligatoria'),
    kgs_a_pagar: yup
      .number('El monto debe ser un número')
      .typeError('Debe ser un número')
      .min(0.0001, 'El precio debe ser mayor a 0')
      .test('is-decimal', 'Solo se permiten cuatro decimales', value => {
        if (value === null || value === undefined) return true;
        return patternNumero4Decimales.test(value);
      })
      .test(
        'max-kgs-pendiente',
        `El peso a pagar no puede superar el peso pendiente ${unidadAcopioConvertible(entregas?.peso_neto_pendiente, coopConfig)}`,
        value => {
          if (value === null || value === undefined) return true;
          if (!entregas || entregas.peso_neto_pendiente === undefined || entregas.peso_neto_pendiente === null) return true;
          const conversion = coopConfig.hasAcopioUnitsExtra() ? coopConfig.acopioUnitsConversion()?.conversion || 1 : 1;
          // Normalizar a unidad base para la comparación
          const valorEnUnidadBase = coopConfig.hasAcopioUnitsExtra() ? Number(value) / conversion : Number(value);
          return valorEnUnidadBase <= Number(entregas.peso_neto_pendiente);
        }
      )
      .required('Información obligatoria'),
    monto_descontar: yup
      .number()
      .transform((value, originalValue) => {
        if (originalValue === '' || originalValue === null || originalValue === undefined) {
          return 0;
        }
        const number = Number(originalValue);
        return isNaN(number) ? undefined : number;
      })
      .test('is-number', 'El valor debe ser un número', value => {
        if (value === null) return true;
        return typeof value === 'number' && !isNaN(value);
      })
      .test('is-positive', 'El precio debe ser mayor a 0', value => {
        if (value === null || value === undefined) return true;
        return value >= 0;
      })
      .test('is-decimal', 'Solo se permiten dos decimales', value => {
        if (value === null || value === undefined) return true;
        return patternNumero2Decimales.test(value);
      })
      .test(
        'max-saldo-pendiente',
        `El monto a descontar no puede ser mayor al saldo pendiente ${coopConfig.currency()?.symbol} ${formatNumber(
          entregas?.saldo_pendiente
        )}`,
        value => {
          if (value === null || value === undefined) return true;
          if (!entregas || entregas.saldo_pendiente === undefined || entregas.saldo_pendiente === null) return true;
          return Number(value) <= Number(entregas.saldo_pendiente);
        }
      )
      .nullable(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    // reset,
    setValue,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onBlur',
    defaultValues: formData,
  });

  const precioXKg = watch('precio_x_kg');
  const kgs_a_pagar = watch('kgs_a_pagar');
  const montoDescontar = watch('monto_descontar');

  const onSubmit = values => {
    setDataForm(values);
    setShowFirma(true);
    setShowForm(false);
  };

  const getMetodosPago = () => {
    Api.getAll('acopios/catalogos/metodos_pago').then(response => {
      let _items = response.data.map(function(item) {
        return { value: item['id'], label: item['nombre'] };
      });
      setMetodosPago(_items);
    });
  };

  const getImporteAPagar = () => {
    if (precioXKg && kgs_a_pagar && !isNaN(Number(precioXKg)) && !isNaN(Number(kgs_a_pagar)) && precioXKg > 0 && kgs_a_pagar > 0) {
      return formatNumber(Number(kgs_a_pagar) * precioXKg);
    }
    return 0;
  };

  const consultaPreciosPrecargados = () => {
        consultaPrecioPorCoop();
        consultaPrecioPorProductor();
        return;
  };

  const consultaPrecioPorCoop = () => {
    if (precioPorKgPrecargado()) {
      // Obneter el precio por cooperativa
      Api.getAll('admin/acopios/precio_por_kg_precargado').then(response => {
        if (typeof response.data[0] !== 'undefined') {
          if (typeof response.data[0].precio !== 'undefined') {
            const monto = parseFloat(response.data[0].precio);
            setValue('precio_x_kg', monto);
          }
        }
      });
    }
  };
    
  const consultaPrecioPorProductor = () => {
    if (precioPorKgPrecargado()) {
      if (precioPorKgPorProductor()) {
        // Obneter el precio por productor
        Api.get('admin/acopios/precio_por_kg_por_productor', id_cuenta).then(response => {
          if (typeof response.data[0] !== 'undefined') {
            if (typeof response.data[0].precio !== 'undefined') {
              const monto = parseFloat(response.data[0].precio);
              setValue('precio_x_kg', monto);
            }
          }
        });
      }
    }
  };

  return (
    <div>
      <CardContainer height={'100%'}>
        <div className="row">
          <div className="col-md-12 col-lg-7">
            {showForm && (
              <CardContainer height={'100%'}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    <div className="col-xl-10 col-lg-12">
                      <p className="titulo-input">{'Registro de pago pendiente'}</p>

                      <Controller
                        control={control}
                        name="fecha_ejecucion"
                        render={({ field }) => (
                          <DatePicker
                            customInput={<ExampleCustomInput />}
                            dateFormat={'dd/MMM/yyyy'}
                            onChange={date => field.onChange(date)}
                            selected={field.value}
                            wrapperClassName="w-100"
                            locale={es}
                          />
                        )}
                      />
                      {errors?.fecha_ejecucion && <div className="invalid-feedback">{errors?.fecha_ejecucion.message}</div>}
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-xl-10 col-lg-12">
                      <p className="titulo-input">{'Datos de pago'}</p>
                    </div>
                  </div>

                  {!isNaN(entregas?.peso_neto_pendiente) ? (
                    entregas?.peso_neto_pendiente > 0 ? (
                      <div className="row" style={{ marginBottom: -20, paddingLeft: 12 }}>
                        <p className={'info-input'}>
                          Peso pendiente a pagar {'  '}
                          <span>&nbsp;&nbsp;=&nbsp;&nbsp;&nbsp;</span>
                          <b>{unidadAcopioConvertible(entregas?.peso_neto_pendiente, coopConfig)}</b>
                        </p>
                      </div>
                    ) : (
                      <div className="row mt-1">
                        <div className="col-xl-10 col-12">
                          <div className="alert alert-danger" style={{ marginBottom: 0 }}>
                            ⚠️ {cuenta?.productor_nombre} no tiene {unit} pendiente a pagar
                          </div>
                        </div>
                      </div>
                    )
                  ) : null}

                  <div className="row mt-4">
                    <div className="col-xl-10 col-lg-12">
                      <FormInputMaterialTest
                        shrink
                        id="precio_x_kg"
                        type="number"
                        name="precio_x_kg"
                        label=""
                        placeholder={`Precio / ${unit} (${coopConfig.currency()?.symbol})`}
                        error={errors.precio_x_kg}
                        register={register}
                        step=".01"
                      />
                    </div>
                    {env.appEnv === '--' && (
                      <div className="col-3 mt-2">
                        <p className="info-input" style={{ marginTop: 0, marginBottom: '3px', fontSize: 14 }}>
                          {/* Esta operación fue corregida por Nacho GM */}
                          {formatMoneyNumber(precioXKg * coopConfig.acopioUnitsConversion()?.conversion || 0)}
                          &nbsp;&nbsp;
                          {`${coopConfig.currency()?.symbol} / ${coopConfig.acopioUnits()?.abreviacion} `}
                        </p>
                      </div>
                    )}
                  </div>

                  <div className="row mt-4">
                    <div className="col-xl-10 col-lg-12">
                      <FormInputMaterialTest
                        id="kgs_a_pagar"
                        type="number"
                        name="kgs_a_pagar"
                        label=""
                        placeholder={`${unit} a pagar`}
                        error={errors.kgs_a_pagar}
                        register={register}
                        step=".0001"
                      />
                    </div>
                    {env.appEnv === '--' && (
                      <div className="col-3 mt-2">
                        <p className="info-input" style={{ marginTop: 0, marginBottom: '3px', fontSize: 14 }}>
                          {formatMoneyNumber(kgs_a_pagar / coopConfig.acopioUnitsConversion()?.conversion || 0)}
                          &nbsp;&nbsp;
                          {coopConfig.acopioUnits()?.abreviacion}
                        </p>
                      </div>
                    )}
                  </div>

                  <div
                    className="row mt-4"
                    style={{
                      paddingLeft: '10px',
                      paddingRight: '10px',
                    }}>
                    <div
                      className="col-xl-10 col-lg-12"
                      style={{
                        paddingLeft: '10px',
                        paddingRight: '10px',
                        paddingTop: '8px',
                        paddingBottom: '8px',
                        borderTop: `1px solid ${env.colors.neutral_100}`,
                      }}>
                      <p style={{ fontSize: 16, marginBottom: 0 }}>
                        Importe total: <b>{formatMoneyNumber(getImporteAPagar()) + ' ' + coopConfig.currency()?.symbol}</b>
                      </p>
                    </div>
                  </div>

                  {pendientePagoCredito > 0 && (
                    <>
                      <div className="row mt-4">
                        <div className="col-xl-10 col-lg-12">
                          <FormInputMaterialTest
                            id="monto_descontar"
                            type="number"
                            name="monto_descontar"
                            label=""
                            placeholder={`Descuento de deudas (${coopConfig.currency()?.symbol})`}
                            error={errors.monto_descontar}
                            register={register}
                            step=".01"
                          />
                        </div>
                      </div>

                      <div
                        className="row mt-4"
                        style={{
                          paddingLeft: '10px',
                          paddingRight: '10px',
                        }}>
                        <div
                          className="col-xl-10 col-lg-12"
                          style={{
                            paddingLeft: '10px',
                            paddingRight: '10px',
                            borderRadius: '2px',
                            paddingTop: '8px',
                            paddingBottom: '8px',
                            borderTop: `1px solid ${env.colors.neutral_100}`,
                          }}>
                          <p style={{ fontSize: 16, marginBottom: 0 }}>
                            Monto a pagar:{' '}
                            <span style={{ fontWeight: 'bold', color: env.colors.primary_500 }}>
                              {formatMoneyNumber(getImporteAPagar() - montoDescontar) + ' ' + coopConfig.currency()?.symbol}
                            </span>
                          </p>
                        </div>
                        {getImporteAPagar() - montoDescontar < 0 ? (
                          <div className="alert alert-danger" style={{ marginBottom: 0 }}>
                            ⚠️ El monto a pagar no puede ser menor a 0
                          </div>
                        ) : null}
                      </div>
                    </>
                  )}

                  <div className="row mt-4 mb-3" style={{ marginTop: 10 }}>
                    <div className="col-xl-10 col-lg-12">
                      <div className="input-group" style={{ borderStyle: 'none' }}>
                        <Controller
                          control={control}
                          name="id_metodo_pago"
                          render={({ field: { onChange, value } }) => (
                            <Select
                              isSearchable={false}
                              placeholder="Método de pago"
                              options={metodosPago}
                              onChange={onChange}
                              value={value}
                              styles={{
                                container: provided => ({
                                  ...provided,
                                  width: '100%',
                                }),
                                placeholder: defaultStyles => {
                                  return {
                                    ...defaultStyles,
                                    fontSize: 14,
                                    // height: 42,
                                  };
                                },
                                control: provided => ({
                                  ...provided,
                                  height: 44,
                                }),
                              }}
                            />
                          )}
                        />
                        {errors?.id_metodo_pago && <div className="invalid-feedback">{errors?.id_metodo_pago.message}</div>}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-6">
                      <button className="btn btn-sirio mt-3" type="submit" disabled={getImporteAPagar() - montoDescontar < 0}>
                        Continuar
                      </button>
                    </div>
                  </div>
                </form>
              </CardContainer>
            )}
            {showFirma && (
              <EntregasXProductorFirmaXKilos
                data={dataForm}
                cuenta={cuenta}
                unit={unit}
                montoPagado={getImporteAPagar() - montoDescontar}
                precioXKg={coopConfig.hasAcopioUnitsExtra() ? precioXKg * coopConfig.acopioUnitsConversion()?.conversion : precioXKg}
                kgs_a_pagar={coopConfig.hasAcopioUnitsExtra() ? kgs_a_pagar / coopConfig.acopioUnitsConversion()?.conversion : kgs_a_pagar}
              />
            )}
          </div>
          <div className="col-md-12 col-lg-5">
            <EntregasXProductorInfoXKilos uuid_cuenta={uuid_cuenta} id_ciclo={id_ciclo} id_cuenta={id_cuenta} />
          </div>
        </div>
      </CardContainer>
    </div>
  );
};

export default EntregasXProductorPagoPendienteXKilos;
